import React from 'react'

import { VStack } from 'govwell-ui'
import { AIChatSessionFragment } from 'types/graphql'

import AIChatDisplay from 'src/pages/AIAssistantHistoryPage/AIChatDisplay'
import { RefetchFnType } from 'src/types'

type Props = {
  session: AIChatSessionFragment
  refetch: RefetchFnType
  onSelectResponse?: (response: string) => void
}

const AISessionDisplay = ({ session: { chats }, refetch, onSelectResponse }: Props) => {
  return (
    <VStack gap={1}>
      {chats?.map((c, index) => (
        <AIChatDisplay
          key={c.id}
          chat={c}
          index={index}
          refetch={refetch}
          onSelectResponse={onSelectResponse}
        />
      ))}
    </VStack>
  )
}

export default React.memo(AISessionDisplay)
